import React from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from '@/components/Modals/Modal';
import { ModalBodyStyled, InputStyled } from './styles';

const ArticleNumberModal = props => {
  const { webComponentConfing, setOpen, getMaterialViaLinkThunk } = props;
  const [value, setValue] = React.useState(webComponentConfing.productId);
  const inputRef = React.useRef(null);

  const handleChange = e => {
    setValue(e.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApply = () => {
    if (value) {
      getMaterialViaLinkThunk(value);
      handleClose();
    }
  };

  return (
    <Modal
      open
      setOpen={setOpen}
      handleClose={handleClose}
      handleApply={handleApply}
      height="150px"
      title={<FormattedMessage id="cmme.productId" defaultMessage="Enter product id" />}
    >
      <ModalBodyStyled>
        <InputStyled
          type="text"
          error={false}
          value={value}
          disabled={false}
          ref={inputRef}
          onChange={handleChange}
          onFocus={() => {
            if (inputRef.current) {
              inputRef.current.select();
            }
          }}
        />
      </ModalBodyStyled>
    </Modal>
  );
};

export default ArticleNumberModal;
